import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {News} from '../../models/news';

@Injectable({
  providedIn: 'root'
})
export class NewsService extends AbstractModelService<News> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/news', News);
  }
}
